import React from "react"
import bgimage from "../../images/header-background.svg"
import appleLogo from "../../images/apple-logo.svg"
import heroImage from "../../images/hero-image.png"

import styled, { keyframes } from "styled-components"

const HeroAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`

const HeroWrapper = styled.div`
  position: relative;
  height: 920px;
  background-color: #cccccc;
  background: url(${bgimage});
  background-size: cover;
  background-position: center;
`

const HeroGroup = styled.div`
  padding: 150px 50px;
  display: flex;

  @media (max-width: 1024px) {
    flex-wrap: wrap;
  }
`

const LeftSide = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 400px;

  @media (max-width: 1024px) {
    text-align: center;
  }
`

const RightSide = styled.div`
  position: relative;
  margin: 0 auto;
  padding: 20px;

  @media (max-width: 1024px) {
    padding-top: 50px;
  }
`

const Headline = styled.h1`
  font-size: 60px;
  line-height: 1.2;
  color: #252323;
  transition: 1s;
  opacity: 0;
  animation-name: ${HeroAnimation};
  animation-duration: 3s;
  animation-delay: 0.1s;
  animation-fill-mode: forwards;
  animation-timing-function: cubic-bezier(0.2, 0.8, 0.2, 1);

  @media (max-width: 860px) {
    font-size: 40px;
  }
`

const SubHeadline = styled.p`
  font-size: 24px;
  line-height: 1.5;
  color: #252323;
  transition: 1s;
  opacity: 0;
  animation: ${HeroAnimation} 3s 0.2s forwards cubic-bezier(0.2, 0.8, 0.2, 1);

  @media (max-width: 860px) {
    font-size: 18px;
  }
`

const AppStoreButton = styled.div`
  display: flex;
  padding: 0 20px;
  background-color: white;
  border-radius: 6px;
  max-width: 180px;
  font-size: 16px;
  box-shadow: 1px 5px 10px rgba(37, 35, 35, 0.25);
  transition: 1s;
  opacity: 0;
  animation: ${HeroAnimation} 3s 0.3s forwards cubic-bezier(0.2, 0.8, 0.2, 1);

  @media (max-width: 1024px) {
    text-align: left;
    margin: 0 auto;
  }

  @media (max-width: 860px) {
    font-size: 14px;
    max-width: 150px;
  }
`

const AppStoreText = styled.p`
  padding-left: 20px;
  line-height: 1.5;
`

const HeroImage = styled.img`
  max-width: 100%;
  height: auto;
`

const Hero = () => (
  <HeroWrapper>
    <HeroGroup>
      <LeftSide>
        <Headline>For Beauty Professionals</Headline>
        <SubHeadline>
          Appointment app built for independent beauty professionals.
        </SubHeadline>
        <a
          href="https://apps.apple.com/us/app/appointix/id1521671056?ign-mpt=uo%3D2"
          target="_blank"
        >
          <AppStoreButton>
            <img src={appleLogo} alt="Appointix App Store link" />
            <AppStoreText>
              Download on the <strong>App Store</strong>
            </AppStoreText>
          </AppStoreButton>
        </a>
      </LeftSide>
      <RightSide>
        <HeroImage src={heroImage} alt="Appointix App Image View" />
      </RightSide>
    </HeroGroup>
  </HeroWrapper>
)

export default Hero
